import * as React from 'react';
import NotFound from '../../screens/NotFound';

class NotFoundContainer extends React.Component {
    public render() {
        return (
            <NotFound />
        ); 
    }
}

export default NotFoundContainer;



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.tsx